// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { MainLink, NavigationContainer, NavigationInner, Navigation } from './partials';

type Props = {
  links: Array<{
    title: string,
    path?: string
  }>
};

export const BottomNavigation = ({ links }: Props) => {
  const iconProps = { size: '18', strokeWidth: '1.8' };

  // const sendGAEvent = (category: string, event: string, label?: string) => {
  //   window.ga('finecttest.send', {
  //     hitType: 'event',
  //     eventCategory: category,
  //     eventAction: event,
  //     eventLabel: label ? label : 'Footer breadcrumb',
  //     nonInteraction: true
  //   });
  // };

  const homeClickNav = () => {
    // sendGAEvent('Advisers navigation', 'Back to: Finect');
  };
  /* eslint-disable */
  const clickNav = event => {
    // const navDestination = event.currentTarget.innerText;
    // sendGAEvent('Advisers navigation', `Nav to: ${navDestination}`);
  };
  /* eslint-enable */

  return (
    <NavigationContainer>
      <NavigationInner>
        <Navigation>
          <MainLink onClick={homeClickNav}>
            <a href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}`} />
          </MainLink>
          <ul>
            {links.map((link, index) =>
              (link.path ? (
                <li key={index}>
                  <ChevronRight {...iconProps} />
                  <Link onClick={clickNav} to={link.path}>
                    {link.title}
                  </Link>
                </li>
              ) : (
                <li key={index}>
                  <ChevronRight {...iconProps} />
                  <span>{link.title}</span>
                </li>
              )))}
          </ul>
        </Navigation>
      </NavigationInner>
    </NavigationContainer>
  );
};
